import { SofaFormValidator } from '@sofology/sofologycomponents';

import { ValidateOperatorTypeDescription } from 'models';
import { isValidByOperator } from './formValidators';

export const numberRequiredValidator = (errorMessage: string): SofaFormValidator<number | null> => (value: number | null) =>
    Promise.resolve(value === null ? errorMessage : null);

export const minValueValidator = (errorMessage: string, min: number): SofaFormValidator<number | null> => (value: number | null) =>
    Promise.resolve((value === null || value < min) ? errorMessage : null);

export const maxValueValidator = (errorMessage: string, max: number): SofaFormValidator<number | null> => (value: number | null) =>
    Promise.resolve((value !== null && value > max) ? errorMessage : null);

// Case to use: if external value (from the same or different form) meets validation condition, then current value is required'.
export const numberRequiredIfValidator = (errorMessage: string, getExternalValue: () => () => number | null, expectedExternalValue: number | null, operator: ValidateOperatorTypeDescription): SofaFormValidator<number | null> => (value: number | null) => {
    let externalValue = getExternalValue()();

    if (externalValue === null && value === null && operator === ValidateOperatorTypeDescription.EqualTo) {
        return Promise.resolve(null);
    }

    if (externalValue === null && value === null && operator !== ValidateOperatorTypeDescription.EqualTo) {
        return Promise.resolve(errorMessage);
    }

    let shouldBeValidated = externalValue === null ? false : isValidByOperator<number>(externalValue, expectedExternalValue as number, operator);

    let required = shouldBeValidated ? (value === null || isValidByOperator<number>(value, expectedExternalValue as number, operator)) : false;

    return Promise.resolve(required ? errorMessage : null);
};

export const compareNumbersByOperatorValidator = (errorMessage: string, getExternalValue: () => () => number | null, operator: ValidateOperatorTypeDescription): SofaFormValidator<number | null> => (value: number | null) => {
    let externalValue = getExternalValue()();

    if (externalValue === null && value === null && operator === ValidateOperatorTypeDescription.EqualTo) {
        return Promise.resolve(null);
    }

    return Promise.resolve(value === null ? null : isValidByOperator<number>(value, externalValue as number, operator) ? errorMessage : null);
};